export class CheckHeaderState {
    private pStatus: "none-checked" | "some-checked" | "all-checked" | "some-unchecked";

    constructor() {
        this.pStatus = "none-checked";
    }

    public clickHeader(): void {
        switch (this.pStatus) {
            case "none-checked":
            case "some-checked":
            case "some-unchecked":
                this.pStatus = "all-checked";
                break;
            case "all-checked":
                this.pStatus = "none-checked";
                break;
        }
    }
    public uncheckLastRow() {
        switch (this.pStatus) {
            case "some-checked":
                this.pStatus = "none-checked";
                break;
            case "some-unchecked":
                this.pStatus = "all-checked";
                break;
        }
    }
    public checkRowUpToAll() {
        switch (this.pStatus) {
            case "some-unchecked":
            case "some-checked":
                this.pStatus = "all-checked";
                break;
        }
    }
    public clickRow(isClient: boolean) {
        switch (this.pStatus) {
            case "none-checked":
                this.pStatus = "some-checked";
                break;
            case "all-checked":
                if (isClient) {
                    this.pStatus = "some-checked";
                } else {
                    this.pStatus = "some-unchecked";
                }
                break;
        }
    }
    get status() {
        return this.pStatus;
    }
}
